import WhyStreamYard from './WhyStreamYard';

export default WhyStreamYard;
